import React from "react";
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box, Flex, Heading, Text } from "theme-ui";
import { colors, typography } from "../../../styles/theme";

const AdvantageFeature = ({ advantageSectionTitle, advantageFeatureList }) => {
  return (
    <Box sx={containerStyle}>
      <Heading
        as="h2"
        sx={headingContainer}
        dangerouslySetInnerHTML={{ __html: advantageSectionTitle }}
      />
      <Flex sx={sectionContainer}>
        {advantageFeatureList?.map((advantageFeatureSection, index) => (
          <Flex
            key={`advantage-feature-${index}`}
            sx={{ flexDirection: "column", alignItems: "center", px: "1.5rem" }}
          >
            {advantageFeatureSection?.image && (
              <Box sx={{ py: "1.5rem" }}>
                <GatsbyImage
                  image={getImage(advantageFeatureSection.image)}
                  alt={advantageFeatureSection.name}
                  sx={{ width: "100%" }}
                />
              </Box>
            )}
            <Text
              sx={{ ...typography.h5, pb: "1.5rem", maxWidth: "15.625rem", textAlign: "center" }}
              dangerouslySetInnerHTML={{ __html: advantageFeatureSection.name }}
            />
          </Flex>
        ))}
      </Flex>
    </Box>
  );
};

const { containerStyle, headingContainer, sectionContainer } = {
  containerStyle: {
    backgroundColor: colors.secondaryGreen100,
    py: ["4rem", "4rem", "7rem", "7rem"],
  },
  headingContainer: {
    ...typography.h2,
    p: { m: 0 },
    textAlign: "center",
    "@media(max-width: 391px)": {
      px: "1rem",
    },
  },
  sectionContainer: {
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "2rem",
    mt: ["3rem", "3rem", "4rem", "4rem"],
  }
};

export default AdvantageFeature;
